export default __webpack_public_path__ + "static/media/reset.10e4c44a.svg";